import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { LocalizedComponentProps } from 'bernie-l10n';
import { RouteStore } from 'bernie-core';

import { UitkCard, UitkCardContent, UitkCardTextSegment } from 'uitk-react-cards';

import { NavigationRefs } from 'components/infosite/navigation/navigation-refs.tsx';
import { ReviewsListOnInfosite } from 'components/infosite/property-details/reviews-list-on-infosite';
import { ReviewsSummary } from 'components/infosite/property-details/reviews-summary';
import { SeeAllReviewsButton } from 'components/common/reviews/review-components';

export interface ReviewsOnInfositeProps extends LocalizedComponentProps {
  routeStore?: RouteStore;
}

@inject('routeStore')
@observer
export class ReviewsOnInfosite extends React.Component<ReviewsOnInfositeProps> {
  public constructor(props) {
    super(props);

    this.openReviewsDialog = this.openReviewsDialog.bind(this);
  }

  private openReviewsDialog() {
    const { routeStore } = this.props;

    routeStore.updateSearch({ pwaDialog: 'reviews' });
  }

  public render() {
    const refsMapReviews = NavigationRefs.Reviews;

    return (
      <div ref={refsMapReviews}>
        <UitkCard data-stid="reviews-on-infosite">
          <UitkCardContent>
            <UitkCardTextSegment>
              <div className="xl-x-padding-three xl-y-padding-three">
                <div className="uitk-grid all-x-gutter-six">
                  <div className="uitk-cell all-cell-1-3 m-cell-1-1 s-cell-1-1">
                    <ReviewsSummary />
                  </div>
                  <div className="uitk-cell all-cell-2-3 m-cell-1-1 s-cell-1-1">
                    <ReviewsListOnInfosite />
                    <SeeAllReviewsButton onClick={this.openReviewsDialog} />
                  </div>
                </div>
              </div>
            </UitkCardTextSegment>
          </UitkCardContent>
        </UitkCard>
      </div>
    );
  }
}
